@if (select.title) {
  <div mat-dialog-title>{{select.title}}</div>
}
<div mat-dialog-content [innerHTML]="select.message"></div>
<mat-form-field appearance="fill">
  <mat-select [(value)]="selectedId">
    @for (option of select.optionList; track option) {
      <mat-option
        [value]="option.getId()">
        {{option.getLabel()}}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
<div mat-dialog-actions align="end">
  <button
    mat-button
    color="primary"
    mat-dialog-close>
    {{select.cancelLabel}}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onConfirm()"
    [disabled]="!this.selectedId">
    {{select.confirmLabel}}
  </button>
</div>
